'use client'

import AboutUs from '@/components/about-us'

export default function AboutPage() {
  return <AboutUs />
}
